import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Home2 from '../views/Home2.vue'
import RelationUserToCompany from '../views/RelateUserToCompany'
import About from '../views/About.vue'
import Login from '../views/Login.vue'
import RegisterUser from '../views/RegisterUser.vue'
import Applications from '../views/Applications.vue'
import Application from '../views/Application.vue'
import Users from '../views/Users.vue'
import Reporting from '../views/Reporting.vue'
import ApplicationAdmin from '../views/admin/ApplicationAdmin.vue'
import CompaniesAdmin from '../views/admin/CompaniesAdmin'
import PaymentAdmin from '../views/admin/PaymentAdmin'
import ApplcationSettingAdmin from '../views/admin/SettingsAdmin';
import CommunicationAdmin from '../views/admin/CommunicationAdmin';
import PasswordReset from '../views/PasswordReset.vue';
import ExportAdmin from '../views/admin/ExportAdmin';
import EmailAdmin from '../views/admin/EmailAdmin';
import ReportsAdmin from '../views/admin/ReportsAdmin';

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'index',
        component: Home
    },
    {
        path: '/home',
        name: 'home',
        component: Home2
    },
    {
        path: '/home2',
        name: 'home2',
        component: Home2
    },
    {
        path: '/relateusertocompany',
        name: 'relateusertocompany',
        component: RelationUserToCompany
    },
    {
        path: '/about',
        name: 'about',
        component: About
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/applications',
        name: 'applications',
        component: Applications
    },
    {
        path: '/application/:id',
        name: 'application',
        component: Application,
        props: true
    },
    {
        path: '/reporting/:id',
        name: 'reporting',
        component: Reporting,
        props: true
    },
    {
        path: '/registeruser',
        name: 'registeruser',
        component: RegisterUser
    },
    {
        path: '/users',
        name: 'users',
        component: Users
    },
    {
        path: '/applicationadmin',
        name: 'applicationadmin',
        component: ApplicationAdmin
    },
    {
        path: '/companiesadmin',
        name: 'companiesadmin',
        component: CompaniesAdmin
    },
    {
        path: '/paymentadmin/:id',
        name: 'paymentadmin',
        component: PaymentAdmin,
        props: true
    },
    {
        path: '/applicationsettingadmin',
        name: 'applicationsettingadmin',
        component: ApplcationSettingAdmin
    },
    {
        path: '/communicationadmin',
        name: 'communicationAdmin',
        component: CommunicationAdmin,
        props: true
    },
    {
        path: '/passwordreset/:token',
        name: 'passwordreset',
        component: PasswordReset,
        props: true
    },
    {
        path: '/exportadmin',
        name: 'exportadmin',
        component: ExportAdmin
    },
    {
        path: '/emailadmin',
        name: 'emailadmin',
        component: EmailAdmin
    },
    {
        path: '/reportsAdmin',
        name: 'reportsAdmin',
        component: ReportsAdmin
    }
]

const router = new VueRouter({
    routes
})

export default router
